import React from 'react';
import Header from '../../Universal/Header';
import Footer from '../../Universal/Footer';
import './Policies.css';

const PrivacyPolicy = () => {
    return (
        <div className="policy-page-header policy-page-wrapper">
            <Header />

            <div className="policy-hero">
                <div className="policy-hero-content">
                    <h1 className="policy-title">Privacy Policy</h1>
                    <p className="policy-intro">Your privacy is important to us.</p>
                </div>
            </div>

            <section className="policy-container">
                <div className="policy-content-wrapper">
                    <div className="policy-main-text">
                        <h3>Data Collection & Usage</h3>
                        <p>The B.E. College Ex-Students’ Club respects your privacy and is committed to protecting your personal information.</p>
                        <ol>
                            <li>We collect basic personal information such as name, email address, phone number, and payment details solely for membership management, communication, and record-keeping purposes.</li>
                            <li>Payment transactions are securely processed through authorized payment gateways (such as Razorpay). The Club does not store your card or net-banking details.</li>
                            <li>Personal information will not be sold, shared, or rented to third parties, except as required by law.</li>
                            <li>We may use your contact details to send official communications related to club activities, events, and announcements.</li>
                            <li>By using our website, you consent to the collection and use of information as outlined in this policy.</li>
                        </ol>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default PrivacyPolicy;
